(function packageRequestForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'PackageRequest',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		Adzuki.onload('/Packages/request', function onload()
		{
			$('#captcha').show();

			$('#packagerequest-sailing_category').change(function categoryChanged() {
				updatePricing($(this));
			});

			$('#packagerequest-number_of_passengers').change(function numPaxChanged(e) {
				var $self         = $(this),
				    numPassengers = $self.val(),
				    $template,
				    i;

				$('.passenger-form').removeClass('active');

				if (numPassengers > 0) {
					for (i = 0; i < numPassengers; i++) {
						$template = $('#passenger_' + (i + 1));

						$template.data('key', i);
						$template.removeClass('hidden')
							.addClass('active');
						$template.find('.form-group input,select')
							.attr('disabled', false);

						$template.find('input[name$="[birthday]"]').siblings('.input-group-addon')
							.addClass('hidden');
					}
				}

				updatePricing($('#packagerequest-sailing_category'));

				$('.passenger-form:not(.active)').addClass('hidden');
			});
		});
	};

	function updatePricing(obj) {
		var num_pax            = parseInt($('#packagerequest-number_of_passengers').val()),
			selected_category  = obj.val(),
			deposit            = Number($('#packagerequest-deposit').val().replace(/[^0-9\.-]+/g, "")),
			category_parts,
			adv_12,
			adv_34,
			package_price,
			final_payment_amount,
			category_dropdown;

		if (num_pax > 0) {
			category_parts = selected_category.split("|");
			adv_12         = category_parts[1];
			adv_34         = category_parts[2];

			if (num_pax > 2) {
				if (adv_34 > 0) {
					package_price = adv_12 * 2;
				} else {
					package_price = adv_12 * num_pax;
				}
			} else {
				package_price = adv_12 * num_pax;
			}

			final_payment_amount = package_price - deposit;

			if (!isNaN(package_price)) {
				$('.package-price').html(accounting.formatMoney(package_price) + ' <small>(includes gov\'t taxes)</small>');
				$('.final-payment-amount').html(accounting.formatMoney(final_payment_amount));

				$('#packagerequest-package_price').val(package_price);
				$('#packagerequest-final_payment_amount').val(final_payment_amount);

				category_dropdown = $('#packagerequest-sailing_category').find('option:selected');

				$('#packagerequest-sailing_category_name').val(category_dropdown.text());
			}
		}
	}

}(jQuery, window.Adzuki || {}));
